import type { CommentItem } from '@/types';

export const tvComments: CommentItem[] = [
  {
    id: 'c1',
    user: '追剧的小满',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20flat%20illustration%20avatar%20of%20a%20friendly%20young%20girl%20with%20a%20bun%20hairstyle%2C%20soft%20warm%20orange%20background%2C%20minimal%20and%20clean%20design&width=120&height=120&seq=cmt-01&orientation=squarish',
    content: '一口气追到第八集，节奏真的很稳，没有为了反转而反转。人物的每一步选择都能自圆其说，这才是好剧该有的样子。',
    time: '2025-10-13 21:40',
  },
  {
    id: 'c2',
    user: '夜航西飞',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20flat%20illustration%20avatar%20of%20a%20calm%20young%20man%20with%20short%20hair%2C%20soft%20indigo%20blue%20background%2C%20minimal%20and%20clean%20design&width=120&height=120&seq=cmt-02&orientation=squarish',
    content: '摄影和美术太加分了，夜景戏很有电影质感。服化道细节经得起暂停截图，能看出剧组是真的用心。',
    time: '2025-10-12 19:02',
  },
  {
    id: 'c3',
    user: '安静的观众',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20flat%20illustration%20avatar%20of%20a%20thoughtful%20person%20with%20glasses%2C%20muted%20green%20background%2C%20minimal%20and%20clean%20design&width=120&height=120&seq=cmt-03&orientation=squarish',
    content: '喜欢这种把情绪藏在细节里的表达方式。很多台词不多，但一个眼神就够了。期待后面的走向。',
    time: '2025-10-10 14:27',
  },
];